import {
  FormControl as MUIFormControl,
  type FormControlProps,
} from '@mui/material';

export { type FormControlProps } from '@mui/material';

export function FormControl(props: FormControlProps) {
  return <MUIFormControl {...props} />;
}
